import React from "react";
import { Card, Typography, Divider, Space, Tag } from "antd";
import { BookOutlined, StarFilled } from "@ant-design/icons";
import "./EducentreCard.less";
import { LectureCover, Discount_icon } from "../../assets/images";

const { Text, Title } = Typography;

const EducentreCard = ({
  coachingName = "Coaching Name",
  rating = "4.2",
  subject,
  batchSize,
  vacancy,
  course_banner,
  batch_start_date,
  batch_end_date,
  onClick,
}) => (
  <div className='educentre-card-container' onClick={onClick}>
    <Card className='lecture-card' style={{ padding: "0px" }}>
      {/* First div: Lecture cover image */}
      <div className='lecture-cover'>
        <img src={course_banner} alt='Lecture Cover' />
      </div>

      {/* Second div: Coaching name, star rating, and distance */}
      <div style={{ padding: "10px" }}>
        <div className='coaching-info'>
          <Title level={4} className='coaching-name'>
            {coachingName}
          </Title>
          <div className='rating-distance'>
            <Space direction='horizontal'>
              <Tag color='#1F4298' className='rating-tag'>
                <Text className='rating'>{rating}</Text>
                <StarFilled className='star-icon' />
              </Tag>
            </Space>
          </div>
        </div>

        {/* Third div: Subject name, batch size, and vacancy */}
        <div className='class-details'>
          <ul className='details-list'>
            <li style={{ listStyle: "none" }}>{subject.toUpperCase()}</li>
            <li>Batch Size: {batchSize}</li>
            <li>Vacancy: {vacancy}</li>
          </ul>
        </div>
        <div className='class-details'>
          <ul className='details-list'>
            <li style={{ listStyle: "none" }}>
              Time Period : {batch_start_date} to {batch_end_date}
            </li>
          </ul>
        </div>

        {/* Divider */}
        <Divider className='divider' />

        {/* Fourth div: Icon and 'Book a free trial class' text link */}
        <div className='booking-section'>
          <img src={Discount_icon} />
          <Text className='booking-text'>Book a free trial class</Text>
        </div>
      </div>
    </Card>
  </div>
);

export default EducentreCard;
